export const getDefaultState = () => {
  return {
    orderDetail: null,
    bs_myp_05_040: null,
    cancelNo: null
  }
}

export const initState = () => {
  // 事前決済 決済GW遷移時用、楽天再ログインリダイレクト用
  const orderDetail = JSON.parse(sessionStorage.getItem('redirectOrderDetail'))
  if(orderDetail){
    sessionStorage.removeItem('redirectOrderDetail')
    return {
      orderDetail: orderDetail,
      bs_myp_05_040: null,
      cancelNo: null
    }
  }
  else{
    return getDefaultState()
  }
}

const state = initState()
export default state
